(function ($) {

	function add_cart_item(e) {

		e.preventDefault();

		gp_ajax({
			url: ghostpress_params.ajax_url + "&action=cart_add_product_variant",
			type: "post",
			dataType: "json",
			data: {
				product_variant_id: $(this).data('quick-buy')
			},
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {
				jQuery(document).trigger('open_modal', ['cart'])
			})
	}

	function init_cart() {
		// Add item to cart
		$('[data-quick-buy]').gp_on('click', add_cart_item)
	}

	// Init cart functions
	$(document).gp_ready(init_cart)

})(jQuery);
